const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the segmentation editor component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('segmentationManager', ['Application', 'Authorization', 'Categories', '$q', '$translate', function (Application, Authorization, Categories, $q, $translate) {
  return {
    restrict: 'E',
    scope: {
      type: '@',
      language: '=',
      refresh: '='
    },
    template: require('../../templates/directives/segmentation-manager.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.languages = Application.languages.getAvailable();

      self.selectLanguage = function(item) {
        item.abr = item.abr.toLowerCase();
        $scope.language = item;
      };

      self.type = $scope.type;

      self.translatedata = {
        type: ($scope.type === 'org_level'? 'Level' : ($scope.type.charAt(0).toUpperCase() + $scope.type.slice(1)))
      };

      self.translationType = {
        type: ($scope.type === 'org_level'? 'Level' : ($scope.type.charAt(0).toUpperCase() + $scope.type.slice(1)))
      };

      self.create = {
        saving: false,
        creating: false,
        document: null,
        cancel: function() {
          self.create.saving = false;
          self.create.creating = false;
          self.create.document = null;
        },
        start: function(category) {
          // Check if open
          if (self.create.creating) {
            $translate('manage.categories.message_saveOrEdit',{ type: $scope.type }).then(function(data){
              Application.messaging.addMessage({type: '', text: data, duration: 5});
            });

            return;
          }

          // Check language
          if ($scope.language && $scope.language.abr !== 'en' && $scope.language.abr !== 'eng') {
            for (var i = 0; i < self.languages.length; i++) {
              if (self.languages[i].abr === 'en') {
                self.selectLanguage(self.languages[i]);
                break;
              }
            }
            $translate('manage.categories.message_createInEnglish',{ type: $scope.type }).then(function(data){
              Application.messaging.addMessage({type: '', text: data, duration: 5});
            });
          }

          // if parent is null then top level category
          if (category) {
            self.information.current_logic.select(category, true);
          }

          self.create.creating = true;

          self.create.document = {
            parent: self.information.active_parent_2 || self.information.active_parent_1 || null,
            children: [],
            name: '',
            level: self.information.active_level,
            localized_names: '',
            category: $scope.type === 'category',
            location: $scope.type === 'location',
            department: $scope.type === 'department',
            team: $scope.type === 'team',
            org_level: $scope.type === 'org_level',
            grade: $scope.type === 'grade'
          };

        },
        submit: function() {
          self.create.saving = true;
          var type = self.type === 'org_level' ? 'organization level' : self.type;
          Categories.create({}, self.create.document).$promise
          .then(function(cat) {
            self.create.saving = false;
            self.create.cancel();

            $translate('manage.categories.message_wasCreated',{ type: type }).then(function(data){
              Application.messaging.addMessage({type: 'success', text: data, duration: 5});
            });

            self.information.current_logic.load();
          }).catch(function(error) {
            console.log({text: 'There was an error attempting to create the ' + type + '.', duration: 6, type: 'error'});
          });
        }
      };

      self.removal = {
        selection: null,
        children: [],
        show: false,
        saving: false,
        cancel: function() {
          self.removal.selection = '';
          self.removal.children = [];
          self.removal.show = false;
        },
        select: function(category) {
          Categories.descendants({subsubresource: category._id}).$promise
          .then(function(results) {
            self.removal.selection = category;
            self.removal.children = results;
            self.removal.show = true;
          }).catch(function(error) {
            self.removal.cancel();
            Application.messaging.addMessage({text: 'There was an error preparing the item for removal. Please try again later.', type: 'error', duration: 6});
          });
        },
        submit: function() {
          if (!self.removal.selection || !self.removal.selection._id) {
            return;
          }
          var type = self.type === 'org_level' ? 'organization level' : self.type;

          self.removal.saving = true;

          Categories.remove({subresource: self.removal.selection._id}).$promise
          .then(function(data) {
            self.removal.saving = false;
            self.removal.cancel();

            self.information.current_logic.load();

            $translate('manage.categories.message_wasDeleted',{ type: type }).then(function(data){
              Application.messaging.addMessage({type: 'success', text: data, duration: 5});
            });

          }).catch(function(error) {
            self.removal.saving = false;
            self.removal.cancel();
            Application.messaging.addMessage({text: 'There was an error removing this item. Please try again later.', type: 'error', duration: 6});
          });
        }
      };

      self.changeIndex = function(level) {
        if (self.newTop || self.newTwo || self.newThree) {
          $translate('manage.categories.message_saveOrEditBeforeChanging',{ type: $scope.type }).then(function(data){
            Application.messaging.addMessage({type: '', text: data, duration: 5});
          });
          return;
        }

        if (level === 3) {
          self.viewIndex = '0%';
          return;
        }

        self.viewIndex = -100/3 * level + '%';

        // scroll top
        document.querySelector('#collection-menu').scrollIntoView(true);
      };

      self.search = {
        search_term: '',
        delayed_load: null
      };

      $scope.$watch('segmentation.search.search_term', function(newVal, oldVal) {
        if (newVal !== oldVal) {
          if (self.search.delayed_load) {
            clearTimeout(self.search.delayed_load);
          }
          var action = self['logic_' + self.information.active_level].refresh;
          self.search.delayed_load = setTimeout(function() {
            action();
            self.search.delayed_load = null;
          }, 500);
        }
      });

      self.information = {
        loading: false,
        per_page: 15,
        active_level: 1,
        current_logic: null,
        active_parent_1: null,
        active_parent_2: null,
        selected_1: null,
        selected_2: null,
        back: function(level) {
          if (self.create.creating) {
            Application.messaging.addMessage({text: 'Please add or cancel current addition before navigating.', type: 'error', duration: 7});
            return;
          }
          if (level === 1) {
            self.changeIndex(0)
            self.information.current_logic = self.logic_1;
            self.logic_2.reset();
            self.logic_3.reset();
          }
          if (level === 2) {
            self.changeIndex(1)
            self.information.current_logic = self.logic_2;
            self.logic_3.reset();
          }
        }
      };

      var Level_logic = function(level) {
        this.level = level;
        this.data = [];
        this.next_available = true;
        this.page = 1;
        var levelThis = this;

        this.next = function() {
          if (!this.next_available) {
            return;
          }
          this.page++;
          this.load();
        };

        this.previous = function() {
          if (this.page <= 1) {
            return;
          }
          this.page--;
          this.load();
        };

        this.reset = function() {
          this.page = 1;
          this.data = [];
          this.next_available = true;
          self.information['selected_' + this.level] = null;
          self.information['active_parent_' + this.level] = null;
        };

        this.refresh = function() {
          levelThis.reset.call(levelThis);
          levelThis.load();
        };

        this.select = function(cat, override) {
          if (self.create.creating) {
            Application.messaging.addMessage({text: 'Please add or cancel current addition before navigating.', type: 'error', duration: 7});
            return;
          }

          if (this.level >= 3 || !cat || !self['logic_' + (1 + this.level)]) {
            return;
          }
          if ((!cat.children || !cat.children.length) && !override) {
            return;
          }

          self.information['selected_' + this.level] = cat;
          self.information['active_parent_' + this.level] = cat._id;
          self.information.active_level = this.level + 1;
          self.information.current_logic = self['logic_' + (1 + this.level)];
          self.information.current_logic.refresh();
          self.changeIndex(this.level);
        };

        this.load = function() {
          var query = {
            type: self.type,
            level: this.level,
            page: this.page,
            per_page: self.information.per_page
          };

          if (this.level === 2 && self.information.active_parent_1) {
            query.parent = self.information.active_parent_1;
          }

          if (this.level === 3 && self.information.active_parent_2) {
            query.parent = self.information.active_parent_2;
          }

          if (self.search.search_term) {
            query.search_term = self.search.search_term;
          }

          self.information.loading = true;

          Categories.managerFind(query).$promise
          .then(function(results) {
            self.information.loading = false;
            levelThis.next_available = results.next_available;
            levelThis.data = results.data;
            if (self.type === 'category' && query.page === 1 && levelThis.data[0] && levelThis.data[0].level === 10) {
              self.information.featured = levelThis.data.shift();
            }
          }).catch(function(error) {
            self.information.loading = false;
            console.log('error: ', error);
          });
        };
      };

      self.logic_1 = new Level_logic(1);
      if (self.type === 'category' || self.type === 'location' || self.type === 'department') {
        self.logic_2 = new Level_logic(2);
        self.logic_3 = new Level_logic(3);
      }


      self.initialize = function() {
        self.information.current_logic = self.logic_1;
        self.information.current_logic.load();
      };

      $translate([
        'manage.categories.deleteWarning',
        'manage.categories.followingSubordinateRemoved',
        'global.actions.delete',
        'global.actions.cancel',
        'manage.categories.viewer_categoriesHome',
        'manage.categories.viewer_LocationsHome',
        'manage.categories.viewer_departmentsHome',
        'manage.categories.viewer_teamsHome',
        'manage.categories.viewer_org_levelsHome',
        'manage.categories.viewer_gradesHome',
        'categoryEditor.action_in_progress',
        'overview.settings.tabs_locations',
        'overview.settings.tabs_departments',
        'overview.settings.tabs_teams',
        'overview.settings.tabs_grades',
        'overview.settings.tabs_org_levels',
        'overview.settings.tabs_categories',
      ]).then(function(data){
        self.translations = data;
        self.overviewTitle = {
          category: self.translations['manage.categories.viewer_categoriesHome'],
          location: self.translations['manage.categories.viewer_LocationsHome'],
          department: self.translations['manage.categories.viewer_departmentsHome'],
          team: self.translations['manage.categories.viewer_teamsHome'],
          org_level: self.translations['manage.categories.viewer_org_levelsHome'],
          grade: self.translations['manage.categories.viewer_gradesHome']
        };
        self.search.placeholders = {
          category: self.translations['overview.settings.categories_tabs_categories'],
          level: self.translations['overview.settings.tabs_org_levels'],
          location: self.translations['overview.settings.tabs_locations'],
          department: self.translations['overview.settings.tabs_departments'],
          team: self.translations['overview.settings.tabs_teams'],
          grade: self.translations['overview.settings.tabs_grades']
        };
        self.initialize();
      });

    }],
    controllerAs: 'segmentation'
  };
}]);
